import React, { useState } from 'react';
import { FaLock, FaUsers, FaGlobe, FaTimes, FaCheck } from 'react-icons/fa';
import './PrivacyModal.css';

const PrivacyModal = ({ isOpen, onClose, onConfirm, groups = [] }) => {
    const [privacy, setPrivacy] = useState('public'); // 'me', 'groups', 'public'
    const [selectedGroups, setSelectedGroups] = useState([]);

    if (!isOpen) return null;

    const options = [
        {
            id: 'public',
            label: 'Público',
            desc: 'Cualquier persona en EcoScienceInnova puede ver esto.',
            icon: <FaGlobe />,
            color: 'var(--eco-green)'
        },
        {
            id: 'groups',
            label: 'Mis Grupos',
            desc: 'Sólo miembros de los grupos seleccionados.',
            icon: <FaUsers />,
            color: 'var(--eco-orange)'
        },
        {
            id: 'me',
            label: 'Sólo yo',
            desc: 'Privado. Sólo tú podrás ver esta publicación.',
            icon: <FaLock />,
            color: 'var(--eco-text-dim)'
        }
    ];

    const toggleGroup = (groupId) => {
        setSelectedGroups(prev =>
            prev.includes(groupId)
                ? prev.filter(id => id !== groupId)
                : [...prev, groupId]
        );
    };

    const handleConfirm = () => {
        onConfirm({
            privacy,
            allowedGroups: privacy === 'groups' ? selectedGroups : []
        });
    };

    return (
        <div className="privacy-modal-overlay">
            <div className="privacy-modal-content">
                <div className="privacy-modal-header">
                    <h3>¿Quién puede ver tu publicación?</h3>
                    <button className="privacy-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="privacy-options-list">
                    {options.map(opt => (
                        <div
                            key={opt.id}
                            className={`privacy-option-card ${privacy === opt.id ? 'selected' : ''}`}
                            onClick={() => setPrivacy(opt.id)}
                        >
                            <div className="privacy-option-icon" style={{ color: opt.color }}>
                                {opt.icon}
                            </div>
                            <div className="privacy-option-info">
                                <span className="privacy-option-label">{opt.label}</span>
                                <span className="privacy-option-desc">{opt.desc}</span>
                            </div>
                            <div className="privacy-option-check">
                                {privacy === opt.id && <FaCheck />}
                            </div>
                        </div>
                    ))}
                </div>

                {privacy === 'groups' && (
                    <div className="privacy-groups-selector">
                        <p className="selector-title">Selecciona los grupos:</p>
                        <div className="groups-grid">
                            {groups.map(group => (
                                <button
                                    key={group.id}
                                    className={`group-pills ${selectedGroups.includes(group.id) ? 'active' : ''}`}
                                    onClick={() => toggleGroup(group.id)}
                                >
                                    {group.icon} {group.name}
                                </button>
                            ))}
                        </div>
                        {selectedGroups.length === 0 && (
                            <p className="groups-warning">Por favor selecciona al menos un grupo.</p>
                        )}
                    </div>
                )}

                <div className="privacy-modal-footer">
                    <button className="privacy-cancel-btn" onClick={onClose}>Cancelar</button>
                    <button
                        className="privacy-confirm-btn"
                        onClick={handleConfirm}
                        disabled={privacy === 'groups' && selectedGroups.length === 0}
                    >
                        Confirmar y Publicar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyModal;
